var _ = require('lodash');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<td><span class="number"><strong>'+
((__t=( paymentNumber ))==null?'':_.escape(__t))+
'</strong></span></td> <td><span class="date">'+
((__t=( date ))==null?'':_.escape(__t))+
'</span></td> <td><span class="dollar-amount">'+
((__t=( numeral(remainingBalance).format(moneyFormat) ))==null?'':_.escape(__t))+
'</span></td> <td><span class="dollar-amount">'+
((__t=( numeral(interestPaid).format(moneyFormat) ))==null?'':_.escape(__t))+
'</span></td> <td><span class="dollar-amount">'+
((__t=( numeral(totalInterestPaid).format(moneyFormat) ))==null?'':_.escape(__t))+
'</span></td>';
}
return __p;
};
